import { render, staticRenderFns } from "./CustomerGrowerForm.vue?vue&type=template&id=bb77901e"
import script from "./CustomerGrowerForm.vue?vue&type=script&lang=js"
export * from "./CustomerGrowerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports